import { ITime } from './animation';

export enum ApprovalStatus {
    None = '',
    NoStatus = 'No status',
    NotApproved = 'Not approved',
    InProgress = 'In progress',
    ForReview = 'For review',
    Approved = 'Approved',
}

export enum CreativeType {
    Animated
}

export interface IPreloadImage {
    frames: number[];
    format: 'jpg' | 'gif' | 'png';
    quality: number;
}

export interface IGifExport {
    frames: ITime[];
    show: boolean;
}
